import { fmt, type Column } from "@nabble/ui";
import { ADMIN_ROLE_ID, type Role } from "../../../api/adminRoles";

export interface RoleRowHandlers {
  open: (role: Role) => void;
  remove: (role: Role) => void;
}

/** The columns of the roles list; the Administrator role can only be viewed, base roles never deleted. */
export function roleColumns({ open, remove }: RoleRowHandlers): Column<Role>[] {
  return [
    {
      key: "name",
      label: "Role",
      minWidth: 280,
      text: (r) => `${r.name} ${r.description}`,
      render: (r) => (
        <div className="nb-cell-stack">
          <strong title={r.name}>{r.name}</strong>
          <span className="nb-cell-sub" title={r.description}>
            {r.description || "No description"}
          </span>
        </div>
      ),
    },
    {
      key: "system",
      label: "Type",
      type: "badge",
      width: 150,
      badge: (r) => (r.system ? { label: "Base role", tone: "neutral" } : { label: "Custom", tone: "info" }),
      filter: {
        options: [
          { value: "true", label: "Base role" },
          { value: "false", label: "Custom" },
        ],
      },
    },
    {
      key: "permissions",
      label: "Permissions",
      type: "number",
      width: 112,
      value: (r) => r.permissions.length,
      text: (r) => fmt.number(r.permissions.length),
    },
    { key: "users", label: "Users", type: "number", width: 112 },
    {
      key: "actions",
      label: "Actions",
      type: "actions",
      width: 92,
      actions: (r) => [
        r.id === ADMIN_ROLE_ID
          ? { label: `View role ${r.name}`, icon: "eye", inline: true, onSelect: () => open(r) }
          : { label: `Edit role ${r.name}`, icon: "edit", inline: true, onSelect: () => open(r) },
        { label: "Delete role", icon: "trash", tone: "danger", onSelect: () => remove(r), hidden: r.system },
      ],
    },
  ];
}
